<template>
  <div class="input-group md-form form-sm form-2 pl-0">
    <input
      id="input-search"
      class="form-control my-0 py-1 amber-border"
      type="text"
      :placeholder="placeHolder"
      v-model="inputValue"
      @keyup.enter="search()"
    />
    <div class="input-group-append">
      <span id="search-button" class="input-group-text" @click="search()">
        <img width="20px" src="@/assets/search.svg" />
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputSearch',
  data() {
    return { inputValue: null };
  },
  props: {
    method: { type: Function },
    placeHolder: String,
  },
  methods: {
    search() {
      this.$emit('searchEvent', this.inputValue);
    },
  },
};
</script>

<style lang="scss" scoped>
#input-search {
  border-right: 0px;
}
#search-button {
  border-left: 0px;
  border-radius: 0px;
  background-color: white;
  border-color: #707070;
  cursor: pointer;
}
</style>
